import { Component, OnInit } from '@angular/core';

import { EguardConfigService } from '../../../../../core/services/config.service';

@Component({
    selector: 'eguard-error-500',
    templateUrl: './error-500.component.html',
    styleUrls: ['./error-500.component.scss']
})
export class EguardError500Component implements OnInit {
    constructor(
        private eguardConfig: EguardConfigService,
    ) {
        this.eguardConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar: 'none',
                footer: 'none'
            }
        });
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/components/errors/500/error-500.component.ts